import { store } from "store/createStore";

// pollyfill for react-redux useDispatch hook
const useDispatch = () => store.dispatch;

export { useDispatch };
